module.exports = __webpack_public_path__ + "img/20190903145518485.72ad3432.jpg";